import $ from "jquery";
import {rates} from './instant'
import {checkSymbols} from "./helpers";
import {getAvailableLoanAmount, getRequestLoanAmount} from "./output";
import {
    checkMaxAmountUsd,
    INFO_BACKGR,
    INFO_BACKGR_CONTENT,
    calcLoanLimitValue,
    CALC_USD_TYPE,
    CALC_BTC_TYPE,
    checkTxStatus, NON_VISIBLE
} from "./refillAdditional";

let exchangeRates = [],
    needGetRate = false,
    needCheckProcessed = false,
    noCalcWithDeposit = true;

const depositCoefficient = 1.2;

const ADD_FUNDS_NOT_ENOUGH_MONEY_USD = $('#refill-not-enough-money-usd'),
      ADD_FUNDS_NOT_ENOUGH_MONEY_BTC = $('#refill-not-enough-money-btc'),
      BTC_IN_ADDR = $('#refill-not-enough-money-btc-wallet'),
      ADD_FUNDS_NOT_ENOUGH_MONEY_MODAL = $('#refillNotEnoughMoney');

const MIN_REFILL_AMOUNT = $('#min-refill-not-enough-money-amount-error');

const calcRefillNotEnoughMoneyValues = (type = CALC_USD_TYPE) => {
    let btcExchangeRate = exchangeRates['BTC']['rate'],
        btcValue,
        usdAmount,
        usdValue = parseFloat(ADD_FUNDS_NOT_ENOUGH_MONEY_USD.val());
    if (btcExchangeRate) {
        if (type === CALC_BTC_TYPE) {
            const btcAmount = ADD_FUNDS_NOT_ENOUGH_MONEY_BTC.val();
            usdAmount = (btcAmount / btcExchangeRate).toFixed(2);
            ADD_FUNDS_NOT_ENOUGH_MONEY_USD.val(usdAmount);
            usdValue = parseFloat(usdAmount);
            btcValue = parseFloat(btcAmount);
        }
        if (type === CALC_USD_TYPE) {
            btcValue = (usdValue * btcExchangeRate).toFixed(8);
            ADD_FUNDS_NOT_ENOUGH_MONEY_BTC.val(btcValue);
        }
    }

    return {
        'usd': usdValue,
        'btc': btcValue,
    }
}

const fillRefillNotEnoughMoneyData = (type = CALC_USD_TYPE, noCalcWithDeposit = false) => {
    const calcData = calcRefillNotEnoughMoneyValues(type, noCalcWithDeposit);
    notEnoughMoneySetAdditional(calcData['usd'], calcData['btc']);
    checkRefillData();
}

const notEnoughMoneySetAdditional = (usdAmount, btcAmount) => {
    let availableAmount = getAvailableLoanAmount();
    availableAmount = availableAmount ? parseFloat(availableAmount) : 0
    let headerAmountText = Math.round((availableAmount + usdAmount / depositCoefficient) * 100) / 100;
    $('#refill-not-enough-loan-limit').text(headerAmountText)
    $('#refill-not-enough-money-loan-amount').text(headerAmountText)
    $('#refill-not-enough-money-top-up-amount').text(btcAmount)
}

const checkRefillData = () => {
    clearRefillError();
    const availableForLoan = getAvailableLoanAmount() ? parseFloat(getAvailableLoanAmount()) : 0
    const refillAmountRequest = ADD_FUNDS_NOT_ENOUGH_MONEY_USD.val()
    const refillAmount = Math.round((availableForLoan + parseFloat(refillAmountRequest)) * 100) / 100;
    if (refillAmount < 50) {
        MIN_REFILL_AMOUNT.removeClass(NON_VISIBLE);
    }
}

const clearRefillError = () => {
    if (!MIN_REFILL_AMOUNT.hasClass(NON_VISIBLE)) {
        MIN_REFILL_AMOUNT.addClass(NON_VISIBLE);
    }
}

const processingAddFunds = (modalType) => {
    rate(modalType);
    needCheckProcessed = true;
}

const refillNotEnoughModalShow = () => {
    ADD_FUNDS_NOT_ENOUGH_MONEY_MODAL.on('show.bs.modal', function (e) {
        needGetRate = true
        processingAddFunds()
    })
}

const refillNotEnoughModalHidden = () => {
    ADD_FUNDS_NOT_ENOUGH_MONEY_MODAL.on('hidden.bs.modal', function (e) {
        $('#qr-code-url').addClass(NON_VISIBLE);
        needGetRate = false;
    })
}

const rate = () => {
    exchangeRates = rates;
    fillRefillNotEnoughMoneyData();
}

const updateRefillNotEnoughMoneyData = (type) => {
    noCalcWithDeposit = false;
    checkSymbols('refill-not-enough-money-btc');
    checkSymbols('refill-not-enough-money-usd');
    checkMaxAmountUsd('refill-not-enough-money-usd');
    fillRefillNotEnoughMoneyData(type);
}

const checkProcessedStatus = () => {
    const waitPaymentLabel = $('#refill-not-enough-money-wait-payment');
    const confirmationBlock = $('#refill-not-enough-money-confirmation-block');
    const txOnline = $('#refill-not-enough-money-transaction-online')
    const txConfirmations = $('#refill-not-enough-money-confirmation-count')
    const btcInAddrValue = BTC_IN_ADDR.val();
    const modalSelector = 'refillNotEnoughMoney';
    checkTxStatus(waitPaymentLabel, confirmationBlock, txOnline, txConfirmations, btcInAddrValue, modalSelector);
}

const activeFieldStyle = () => {
    ADD_FUNDS_NOT_ENOUGH_MONEY_USD.focusin(function () {
        $('#refill-not-enough-money-prepend-usd').addClass(INFO_BACKGR);
        $('#refill-not-enough-money-prepend-usd-text').addClass(INFO_BACKGR_CONTENT);
    });
    ADD_FUNDS_NOT_ENOUGH_MONEY_USD.focusout(function () {
        $('#refill-not-enough-money-prepend-usd').removeClass(INFO_BACKGR);
        $('#refill-not-enough-money-prepend-usd-text').removeClass(INFO_BACKGR_CONTENT);
    });
    ADD_FUNDS_NOT_ENOUGH_MONEY_BTC.focusin(function () {
        $('#refill-not-enough-money-prepend-btc').addClass(INFO_BACKGR);
        $('#refill-not-enough-money-prepend-btc-text').addClass(INFO_BACKGR_CONTENT);
    });
    ADD_FUNDS_NOT_ENOUGH_MONEY_BTC.focusout(function () {
        $('#refill-not-enough-money-prepend-btc').removeClass(INFO_BACKGR);
        $('#refill-not-enough-money-prepend-btc-text').removeClass(INFO_BACKGR_CONTENT);
    });
}

export const refillNotEnoughModalDisplay = (loanAmount) => {
    let amount = parseFloat(loanAmount)
    $('#refill-not-enough-money-loan-amount').text(getRequestLoanAmount())
    let currentAvailableAmount = getAvailableLoanAmount()
    if (currentAvailableAmount) {
        currentAvailableAmount = parseFloat(currentAvailableAmount);
        amount = Math.round((amount - currentAvailableAmount) * depositCoefficient * 100 ) / 100;
    }
    ADD_FUNDS_NOT_ENOUGH_MONEY_USD.val(amount)
    $(ADD_FUNDS_NOT_ENOUGH_MONEY_MODAL).modal('show')
    fillRefillNotEnoughMoneyData(CALC_USD_TYPE, true)
}

$(document).ready(() => {
    activeFieldStyle();
    refillNotEnoughModalShow();
    refillNotEnoughModalHidden();
    setInterval(function () {
        if (needGetRate) {
            rate();
        }
    }, 60 * 1000);
    setInterval(function () {
        if (needCheckProcessed && BTC_IN_ADDR) {
            checkProcessedStatus();
        }
    }, 60 * 1000);
});

window.updateRefillNotEnoughMoneyData = updateRefillNotEnoughMoneyData;
